import React, { useContext } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import Image from '../../../atoms/images/Image';
import { AppContext } from '../../../../contexts/AppContext';
import Paragraph from '../../../atoms/paragraphs/Paragraph';

const MbReferenceModal = ({ intl, ...props }) => {
  const { appState } = useContext(AppContext);
  const { paymentReference } = props;
  return (
    <div className='d-flex flex-column flex-grow-1 w-100'>
      <div className='d-flex flex-column flex-md-row m-auto'>
        <div className='col-12 col-md-6 mb-4 mb-md-0'>
          <div className='d-flex flex-column mb-reference-info-container'>
            <div className='d-flex flex-row mb-2'>
              <div>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='55'
                  height='55'
                  viewBox='0 0 55 55'
                  fill='none'
                >
                  <path
                    d='M54.4988 27.289C54.4988 32.5808 52.9296 37.7539 49.9896 42.1539C47.0495 46.5539 42.8708 49.9833 37.9817 52.0084C33.0926 54.0334 27.7128 54.5632 22.5226 53.5308C17.3324 52.4983 12.565 49.9499 8.82313 46.208C5.08127 42.466 2.53309 37.6984 1.50082 32.5082C0.468542 27.318 0.998543 21.9382 3.02379 17.0492C5.04905 12.1602 8.47859 7.98154 12.8787 5.04167C17.2789 2.1018 22.452 0.532761 27.7438 0.532959C34.8398 0.533224 41.645 3.35227 46.6625 8.36996C51.68 13.3877 54.4988 20.193 54.4988 27.289ZM24.6488 41.456L44.4998 21.605C44.6601 21.4447 44.7873 21.2544 44.874 21.045C44.9607 20.8356 45.0054 20.6111 45.0054 20.3845C45.0054 20.1578 44.9607 19.9333 44.874 19.7239C44.7873 19.5145 44.6601 19.3242 44.4998 19.164L42.0588 16.723C41.8986 16.5627 41.7083 16.4355 41.4989 16.3488C41.2894 16.262 41.065 16.2174 40.8383 16.2174C40.6117 16.2174 40.3872 16.262 40.1778 16.3488C39.9684 16.4355 39.7781 16.5627 39.6178 16.723L23.4278 32.911L15.8698 25.353C15.7096 25.1927 15.5193 25.0655 15.3099 24.9788C15.1004 24.892 14.876 24.8474 14.6493 24.8474C14.4227 24.8474 14.1982 24.892 13.9888 24.9788C13.7794 25.0655 13.5891 25.1927 13.4288 25.353L10.9878 27.794C10.6647 28.1176 10.4833 28.5562 10.4833 29.0135C10.4833 29.4707 10.6647 29.9094 10.9878 30.233L22.2078 41.453C22.3681 41.6132 22.5584 41.7404 22.7678 41.8271C22.9772 41.9139 23.2017 41.9585 23.4283 41.9585C23.655 41.9585 23.8794 41.9139 24.0889 41.8271C24.2983 41.7404 24.4886 41.6132 24.6488 41.453V41.456Z'
                    fill='#18BB80'
                  />
                </svg>
              </div>
              <div className='text-header brand h3 ms-4 m-auto'>
                {intl.messages['mbReferenceSuccessTitle']}
              </div>
            </div>

            <div className='d-flex flex-col mb-4'>
              <Paragraph className='text-paragraph'>
                {intl.messages['mbReferenceEmailMessage'] +
                  (appState?.userEmail ? appState?.userEmail : '')}
              </Paragraph>
            </div>

            <div className='d-flex flex-column position-relative gap-3'>
              <div className='d-flex flex-row justify-content-between'>
                <Paragraph className='text-header-black my-auto'>
                  {intl.messages['mbReferenceEntity']}
                </Paragraph>
                <Paragraph className='text-paragraph-lg my-auto'>
                  {paymentReference?.entity || '-'}
                </Paragraph>
              </div>

              <div className='d-flex flex-row justify-content-between'>
                <Paragraph className='text-header-black my-auto'>
                  {intl.messages['mbReferenceReference']}
                </Paragraph>
                <Paragraph className='text-paragraph-lg my-auto'>
                  {paymentReference?.reference || '-'}
                </Paragraph>
              </div>

              <div className='d-flex flex-row justify-content-between'>
                <Paragraph className='text-header-black my-auto'>
                  {intl.messages['mbReferenceAmount']}
                </Paragraph>
                <Paragraph className='text-paragraph-lg my-auto'>
                  {paymentReference?.amount || '-'} €
                </Paragraph>
              </div>

              <div>
                <div className='divider'></div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-12 col-md-6'>
          <div className='d-flex flex-column px-5 pt-2'>
            <Paragraph className='text-header bold gray h4 text-center mb-4'>
              <FormattedMessage
                id='mbReferenceImageDescription'
                defaultMessage='mbReferenceImageDescription'
                values={{
                  linebreak: <br />,
                }}
              />
            </Paragraph>
            <div className='checkout-success-image-wrapper m-auto'>
              <Image
                src={
                  'https://invoicexpress-assets.s3.eu-west-1.amazonaws.com/zen.png'
                }
                alt='success'
                className='checkout-success-image'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(MbReferenceModal);
